'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var TextInput = require('@narvar/nth-block-text-input');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);

const Container = styled__default["default"].div.withConfig({
  componentId: "sc-1mcrec-0"
})(["padding:2rem 1.5rem;display:flex;flex-direction:column;gap:1rem;text-align:", ";"], theme => theme.layout === 'centered' ? 'center' : 'left');
const FormWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1mcrec-1"
})(["box-sizing:border-box;"]);
const FormFieldsWrapper = styled__default["default"].form.withConfig({
  componentId: "sc-1mcrec-2"
})(["display:flex;flex-direction:column;gap:14px;text-align:left;"]);
const InputFieldWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1mcrec-3"
})([""]);
const StyledTextInput = styled__default["default"](TextInput__default["default"]).withConfig({
  componentId: "sc-1mcrec-4"
})(["height:45px;"]);
const GiftReturnToggleWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1mcrec-5"
})(["display:flex;flex-direction:column;align-items:", ";gap:14px;hr{width:100%;}"], theme => theme.layout === 'centered' ? 'center' : 'start');
const CaptionText = styled__default["default"].div.withConfig({
  componentId: "sc-1mcrec-6"
})(_ref => {
  let {
    theme
  } = _ref;
  return {
    ...theme.bodytextDefaultNone,
    ...theme.captiontextDefaultNone
  };
});

exports.CaptionText = CaptionText;
exports.Container = Container;
exports.FormFieldsWrapper = FormFieldsWrapper;
exports.FormWrapper = FormWrapper;
exports.GiftReturnToggleWrapper = GiftReturnToggleWrapper;
exports.InputFieldWrapper = InputFieldWrapper;
exports.StyledTextInput = StyledTextInput;
